import src from "IMAGE";
export default { src, width: 2328, height: 663, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/APrixtC3YamdO6ykPoWgO4u3RaC5UuTdqQD6uHPrlSt6fCttezeHhDjBhjLUs2vo6t7LbRwE5+HzJgAAAABJRU5ErkJggg=="};
